var exports = {
  "kL": "VideoPlayer.module__container___VjdKbl",
  "Ki": "VideoPlayer.module__video___VjdKbl",
  "ER": "VideoPlayer.module__videoHidden___VjdKbl",
  "mz": "VideoPlayer.module__seekPreviewVideo___VjdKbl",
  "IN": "VideoPlayer.module__posterOverlay___VjdKbl",
  "lW": "VideoPlayer.module__posterImage___VjdKbl",
  "aO": "VideoPlayer.module__thumbHashPlaceholder___VjdKbl",
  "HT": "VideoPlayer.module__playOverlayButton___VjdKbl",
  "$Z": "VideoPlayer.module__controlsOverlay___VjdKbl",
  "hr": "VideoPlayer.module__progressBar___VjdKbl",
  "xu": "VideoPlayer.module__controlsRow___VjdKbl",
  "it": "VideoPlayer.module__controlsLeft___VjdKbl",
  "QE": "VideoPlayer.module__controlsCenter___VjdKbl",
  "BT": "VideoPlayer.module__controlsRight___VjdKbl",
  "sL": "VideoPlayer.module__playPauseIndicator___VjdKbl",
  "HA": "VideoPlayer.module__fillContainer___VjdKbl",
  "Y5": "VideoPlayer.module__fullscreen___VjdKbl",
};

module.exports = exports;
